/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MiningRewardSummaryResponse } from './mining-reward-summary-response';


export interface MiningRewardSummaryResponsePagedList { 
    totalCount?: number;
    items?: Array<MiningRewardSummaryResponse> | null;
}

